// Opens a centered popup and resolves when the callback page posts a message
export function openOAuthPopup(authorizeUrl, { name = "OAuthLogin", width = 520, height = 700, timeoutMs = 120000 } = {}) {
  console.log("getRedirectUri base url openOAuthPopup authorizeUrl :", authorizeUrl);
  return new Promise((resolve, reject) => {
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const screenWidth = window.innerWidth || document.documentElement.clientWidth || (window.screen ? window.screen.width : undefined);
    const screenHeight = window.innerHeight || document.documentElement.clientHeight || (window.screen ? window.screen.height : undefined);

    const left = screenWidth / 2 - width / 2 + dualScreenLeft;
    const top = screenHeight / 2 - height / 2 + dualScreenTop;

    const features = `scrollbars=yes,width=${width},height=${height},top=${top},left=${left}`;
    const popup = window.open(authorizeUrl, name, features);

    if (!popup) {
      reject(new Error("Popup blocked. Please allow popups and try again."));
      return;
    }

    popup.focus();

    let completed = false;
    const expectedOrigin = window.location.origin;

    const cleanup = () => {
      completed = true;
      window.removeEventListener("message", onMessage);
      if (checkClosedInterval) clearInterval(checkClosedInterval);
      if (timeoutHandle) clearTimeout(timeoutHandle);
    };

    const onMessage = (event) => {
      // Accept from callback page only; ignore others
      if (!event || !event.data || event.data.type !== "oauth_callback") return;
      // Validate origin matches our app's origin
      if (event.origin !== expectedOrigin) {
        // Ignore unexpected origins for safety
        return;
      }
      cleanup();
      if (event.data.error) {
        reject(new Error(event.data.error_description || event.data.error));
      } else {
        resolve(event.data);
      }
      try { popup.close(); } catch (_) {}
    };

    window.addEventListener("message", onMessage);

    const checkClosedInterval = setInterval(() => {
      if (completed) return;
      if (popup.closed) {
        cleanup();
        reject(new Error("Popup closed before completing sign in."));
      }
    }, 500);

    const timeoutHandle = setTimeout(() => {
      if (completed) return;
      cleanup();
      try { popup.close(); } catch (_) {}
      reject(new Error("Login timed out. Please try again."));
    }, timeoutMs);
  });
}


